/*
  英语
*/
export default {
  headerBar: {
    allProducts: 'All Products',
    newIn: 'New In',
    bestSellers: 'Best Sellers',
    specialOffer: 'Special Offer',
    explore: 'Explore',
    fashionTrends: 'Fashion Trends',
    whyUs: 'Why Us',
    helpCenter: 'Help Center',
    company: 'Company',
    dropshipping: 'Dropshipping',
    aboutUs: 'About Us',
    blog: 'Blog',
    login: 'Sign In',
    register: 'Sign Up for Free',
    searchingFor: 'Searching for',
    wishList: 'Favorite Item',
    listing: 'Listing',
    allOrder: 'All Orders',
    accountSetting: 'Account Setting',
    logOut: 'Sign Out',
    home: 'Home',
    startSelling: 'Start Selling',
    wholesale: 'Wholesale'
  },
  indexPage: {
    hello: 'Hello',
    allCategory: 'All Category',
    apparelWholesale: 'Apparel Wholesale',
    smartDropshiping: 'Smart Dropshiping',
    smallMOQCustomization: 'Small MOQ Customization',
    fastWorldwideShipping: 'Fast Worldwide Shipping',
    estimateShippingCost: 'Estimate Shipping Cost',
    flashSale: 'Flash Sale',
    customization: 'Customization',
    customizationText1: 'With 500+ suppliers and 100+ designers, ',
    customizationText2: 'exclusive products can be customized ONLY for you.',
    ins: "Influencers' Pick",
    insText1: 'Latest styles on fashion trend to get outfits inspo.',
    insText2: 'Same designs to match and supply for your selling.',
    youMayLike: 'You May Like',
    viewMore: 'View More'
  },
  Index: {
    Similar: {
      Home: 'Home',
      VisualSearch: 'Visual Search',
      Products: 'products',
      UploadAPicture: 'upload a picture',
      Tips1: 'upload image to search and match',
      Tips2: 'Max 2MB per Image',
      INeedCustomization: 'I Need Customization'
    },
    ShoppingCar: {
      Back: 'Back',
      ShippingAddress: 'Shipping Address',
      China: 'China',
      Tips1: 'Can support most country configurations',
      Germany: 'Germany',
      Tips2: 'Only local country configurations are supported.',
      Tips3: 'For example:US products are only supported for shipping to the US.',
      Edit: 'Edit',
      Choose: 'Choose',
      AddNewAddress: 'Add New Address',
      ShoppingBag: 'Shopping Bag',
      Tips4: "There're items that from",
      Warehouses: 'warehouses',
      Tips5: 'Items from different warehouses cannot be checked out at the same time.',
      ItemsFrom: 'Items from',
      Tips6: 'warehouse can only ship within the country.',
      SelectAll: 'Select All',
      Delete: 'Delete',
      Weight: 'Weight',
      Subtotal: 'Subtotal',
      YourBagIsEmpty: 'Your bag is empty',
      StartShopping: 'Start Shopping',
      DeliveryMethod: 'Delivery Method',
      LogisticsError: 'Logistics error',
      Tips7: 'Please connect our support team to continue',
      AddKakaCloCode: 'Add KakaClo Code',
      Apply: 'Apply',
      Tips8: 'Deduction for highest product price',
      OrderAmount: 'Order Amount',
      ShippingFee: 'Shipping Fee',
      Discount: 'Discount',
      PromoCode: 'Promo Code',
      Total: 'Total',
      YouHaveSelected: 'You have selected',
      OutOf: 'out of',
      ToCheckout: 'to checkout',
      Tips9: 'Express payment options at checkout',
      Tips10: 'We accept return of products. Customers have the right to apply for a return within 14 days after the receipt of the product.To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging. To complete your return, we require a receipt or proof of purchase. Please do not send your purchase back to the manufacturer.',
      Tips11: 'For after-sales issues, buyers should file a return & refund application within 30 days from the delivery day. Once the buyer submits the after-sales application, he/she needs to provide evidence (as the clause said below) to the kakaclo. If the buyer cannot provide compelling evidence in time, the kakaclo have the right to reject the refund or return the application.',
      Tips12: 'If the buyer fills in the receiving information incorrectly, please contact the customer service or docking personnel in time to confirm whether the goods have been shipped. If there is no delivery, the buyer can update the delivery address with the correct information. If the goods have been shipped, the buyer needs to contact the logistics company to redeliver. If the refund application is approved, the buyer must return the product at his own expense and upload the return tracking information in a timely manner. After kakaclo receives the returned goods without any damage, part of the order amount will be deducted as the cost of repackaging and restocking. If the goods cannot be redistributed or returned, the buyer shall bear the corresponding losses.',
      HowToReturn: 'How to return',
      ReturnAndReturnIssues: 'Return and return issues',
      WrongReceiptInformation: 'Wrong receipt information',
      Tips13: 'Items from different warehouses cannot be checked out at the same time.',
      Tips14: 'Are you sure you want to remove all items from',
      Cancel: 'Cancel',
      Sure: 'Sure',
      Tips15: 'Please note : you may NOT able to make any changes afrer order confirmation',
      DontAskMeAgain: "Don't ask me again",
      LetMeCheckAgain: 'Let me check again',
      GotIt: 'Got It',
      EnterPromoCode: 'Enter Promo Code',
      Tips16: 'Are you sure to delete this item?'
    },
    ShippingCost: {
      Home: 'Home',
      EstimateShippingCost: 'Estimate Shipping Cost',
      ShippingCalculation: 'Shipping  Calculation',
      ShipForm: 'Ship Form',
      ShipTo: 'Ship To',
      Weight: 'Weight',
      Inquire: 'Inquire',
      Tips1: 'Logistics service provider',
      DeliveryTime: 'deliveryTime',
      Cost: 'Cost'
    },
    ProductList: {
      Home: 'Home',
      // AllProducts: 'All Products',
      AllProducts: 'Mall',
      Category: 'Category',
      Prices: 'Prices',
      NoProductFound: 'No product found',
      Tips1: 'We think you’ll love these',
      Fabric: 'Fabric',
      Price: 'Price',
      Products: 'Products',
      ClearAll: 'Clear All',
      Submit: 'submit',
      ShipFrom: 'Ship From',
      SortWay: 'Sort Way'
    },
    PaymentPage: {
      UnderReview: 'Under Review',
      AuditRejected: 'Audit Rejected',
      AvailableBalance: 'Available Balance',
      ApplyNow: 'Apply Now',
      Tips40seas1: 'Unable to use for orders below $2000',
      PaymentPage: 'Payment Page',
      Tips1: 'Please select your payment method',
      Paypal: 'Paypal',
      Creditcard: 'Creditcard',
      Others: 'Others',
      PayNow: 'Pay Now',
      PayLater: 'Pay Later',
      DeliveryMethod: 'Delivery Method',
      Warehouses: 'Warehouses',
      Notes: 'Notes',
      CustomizedService: 'Customized Service',
      Weight: 'Weight',
      ShippingAddress: 'Shipping Address',
      Choose: 'Choose',
      Edit: 'Edit',
      OrderAmount: 'Order Amount',
      Subtotal: 'Subtotal',
      ShippingFee: 'Shipping Fee',
      Discount: 'Discount',
      PromoCode: 'Promo Code',
      Total: 'Total',
      Tips2: 'We accept return of products. Customers have the right to apply for a return within 14 days after the receipt of the product.To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging. To complete your return, we require a receipt or proof of purchase. Please do not send your purchase back to the manufacturer.',
      Tips3: 'For after-sales issues, buyers should file a return & refund application within 30 days from the delivery day. Once the buyer submits the after-sales application, he/she needs to provide evidence (as the clause said below) to the kakaclo. If the buyer cannot provide compelling evidence in time, the kakaclo have the right to reject the refund or return the application.',
      Tips4: 'If the buyer fills in the receiving information incorrectly, please contact the customer service or docking personnel in time to confirm whether the goods have been shipped. If there is no delivery, the buyer can update the delivery address with the correct information. If the goods have been shipped, the buyer needs to contact the logistics company to redeliver. If the refund application is approved, the buyer must return the product at his own expense and upload the return tracking information in a timely manner. After kakaclo receives the returned goods without any damage, part of the order amount will be deducted as the cost of repackaging and restocking. If the goods cannot be redistributed or returned, the buyer shall bear the corresponding losses.',
      // Tips5: 'Leave us your requirement',
      Tips5: 'Add A Note to KakaClo',
      Description: 'Description',
      UnitPrice: 'Unit Price',
      Tags: 'Tags',
      Package: 'Package',
      Bags: 'Bags',
      HowToReturn: 'How to return',
      Tips6: 'Return and return issues',
      Tips7: 'Wrong receipt information'
    },
    MobileSearchCenter: {
      Cancel: 'Cancel'
    },
    MobileExploreDetail: {
      Following: 'Following',
      ViewMore: 'View More',
      PackUp: 'Pack Up',
      ClothingElements: 'Clothing Elements',
      Color: 'Color',
      Pattern: 'Pattern',
      Material: 'Material',
      Excipients: 'Excipients',
      Style: 'Style',
      Gender: 'Gender',
      Contour: 'Contour',
      ShopSimilar: 'Shop Similar',
      UploadAPicture: 'upload a picture'
    },
    Index: {
      LoginExperience: 'Login Experience',
      NoRecommendedProduct: 'No Recommended Product',
      ViewMore: 'View More'
    },
    FestivalCollection: {
      EventExpried: 'Event Expried',
      ViewMore: 'View More'
    },
    ExploreCopy: {
      Home: 'Home',
      Explore: 'Explore',
      ShopSimilar: 'Shop Similar',
      Following: 'Following',
      UploadAPicture: 'upload a picture'
    },
    Explore: {
      Area: 'Area',
      ViewMore: 'View More',
      ReleaseTime: 'Release Time',
      Category: 'Category',
      Followers: 'Followers',
      DesignElements: 'Design Elements',
      Color: 'Color',
      Style: 'Style',
      Tips1: 'Log in to view more',
      Login: 'Login',
      Tips2: 'Welcome to Instagram Fashion Explore',
      SignUp: 'Sign up',
      Or: 'or',
      LogIn: 'Log in',
      Tips3: 'to unlock more fashion posts.',
      ClearAll: 'Clear All',
      Filter: 'Filter',
      ShopSimilar: 'Shop Similar',
      Following: 'Following',
      SorryNoDataFound: 'Sorry, No Data Found',
      PackUp: 'Pack Up',
      ClothingElements: 'Clothing Elements',
      Pattern: 'Pattern',
      Material: 'Material',
      Excipients: 'Excipients',
      Gender: 'Gender',
      Contour: 'Contour',
      Cancel: 'Cancel',
      Submit: 'Submit',
      LoginExperience: 'Login Experience',
      UploadAPicture: 'upload a picture',
      Colors: 'Colors',
      Fans: 'Fans'
    },
    Discount: {
      OFF: 'OFF',
      EventExpried: 'Event Expried'
    },
    Components: {
      UploadPopout: {
        VisualSearch: 'Visual Search',
        Tips1: 'Upload Image to Search and Match',
        Max5MBPerImage: 'Max 5MB per Image',
        UploadImage: 'Upload Image'
      },
      Time: {
        Days: 'Days'
      },
      ProductEmpty: {
        Tips1: 'Did not find what you want,You can click "I Need Customization',
        INeedCustomization: 'I Need Customization'
      },
      Header: {
        Currency: 'Currency',
        Save: 'Save',
        PersonalCenter: 'Personal Center'
      },
      FlashSale: {
        EndsIn: 'Ends In',
        EventExpried: 'Event Expried',
        ViewMore: 'View More'
      },
      Filter: {
        ClearAll: 'Clear All',
        Filter: 'Filter'
      },
      CarFlashTime: {
        EndIn: 'End in'
      }
    },
    Album: {
      Components: {
        TemplateTwo: {
          NoProductFound: 'No product found'
        },
        TemplateOne: {
          All: 'All',
          ViewMore: 'View More',
          NoProductFound: 'No product found'
        }
      }
    },
    IndexPage: {
      title: 'Wholesale Clothing Suppliers',
      description: `
      <div>
        Welcome to our online boutique wholesale clothing store, your ultimate destination for an extensive range of fashionable apparel at wholesale prices. At KakaClo, we pride ourselves on offering a diverse and trendy collection of wholesale clothing, ensuring that your boutique remains stocked with the latest in vogue fashion pieces. 
      </div>
      <div>
        Our primary goal is to be your one-stop-shop for all your boutique's fashion needs. Leveraging strong connections with local wholesale markets, we offer an impressive selection of the trendiest and hottest fashion pieces in the industry. This includes a diverse range such as women's tops, T-shirts, jackets, holiday dresses, party dresses, men's jackets, sweatpants, underwear, loungewear, and jeans. We understand the dynamic nature of fashion and continuously update our inventory to provide you with the freshest and most sought-after styles.
      </div>
      <div>
        A Variety of Styles to Suit Your Boutique</div>
      </div>
      <div>
        From chic and elegant to casual and trendy, our inventory encompasses a broad spectrum of styles to cater to various fashion preferences. In addition to women's and men's clothing, we also specialize in the wholesale of daily and fashionable clothing for pregnant women, oversized women's clothing, parent-child clothing, Halloween clothing, Victory Day clothing, Christmas clothing, and other holiday-themed clothing. We offer a wide range of accessories to complement our diverse collection.
      </div>
      <div>
        Whether your boutique/'s signature style revolves around sophisticated evening wear, comfortable casual attire, or statement pieces for the fashion-forward, we have an array of options to suit your discerning clientele.
      </div>
      <div>
        Quality, Affordability, and Convenience
      </div>
      <div>
        Quality is a non-negotiable aspect of our wholesale clothing collection. We ensure that each piece meets high standards, combining trendy designs with durability. Moreover, our commitment to providing wholesale prices enables you to curate a high-quality collection at affordable rates, enhancing both your inventory and profit margins.
      </div>
      <div>
        Shop Now and Elevate Your Boutique
      </div>
      <div>
        We invite you to explore our online platform and peruse our curated selection. Stock up your boutique with the latest in fashion trends without compromising on quality or breaking the bank. Elevate your boutique's offerings with our wholesale fashion clothing, and keep your customers coming back for more.
      </div>
      <div>
        At KakaClo, we’re dedicated to providing unparalleled service and the trendiest apparel to boost your boutique's success in the competitive fashion market.
      </div>
      <div>
        Shop now and experience the fusion of affordability, diversity, and style in our wholesale fashion hub!
      </div>`
    },
    page404: {
      Tips1: 'Sorry, the page you are looking for cannot be found.',
      GoBack: 'Go Back'
    }
  }
}
